import React from 'react'
import AppBanner from '../components/AppBanner'
export default function AppMobile(){
  return <AppBanner />
}
